/* ==========================================================================
  lazyload.js
========================================================================== */

document.addEventListener('lazybeforeunveil', function(e){
  var el = e.target;

  // polyfill
  if (typeof objectFitPolyfill === "function") {
    objectFitPolyfill();
  }
  el.addEventListener('load', function() {
    if (typeof objectFitPolyfill === "function") {
      objectFitPolyfill();
    }
  });

  el.addEventListener('load', function() {
    // when loaded, animate blurry version
    var siblings = [];
    var sibling = el.parentNode.firstChild;
    for ( ; sibling; sibling = sibling.nextSibling ) {
      if (sibling.nodeType === 1 && sibling !== el && sibling && sibling !== null && sibling !== undefined) {
        if (typeof sibling.classList.contains !== "undefined" && sibling.classList.contains('lazyload-preload')) {
          sibling.classList.add('lazyload-preload--ready');
        }
      }
    }
  });
});
